<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("notice.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <router-link to="/societyadmin/notice/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Notice
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="notices"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
              <template v-slot:item.title="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.title }}
                </div>
              </template>
              <template v-slot:item.description="{ item }">
                <div class="text-truncate" style="max-width: 150px">
                  {{ item.description }}
                </div>
              </template>
              <template v-slot:item.created_at="{ item }">
                {{ getFormattedDate(item.created_at) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="view_notice"
                  title="View Notice"
                  style="margin-left: -10px"
                  :to="'/societyadmin/notice/view/' + item.id"
                >
                  <img src="@/components/icons/view.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="edit_notice"
                  title="Edit Notice"
                  :to="'/societyadmin/notice/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_notice"
                  title="Delete Notice"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteNotice(delete_id)">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("notice.headers.title")}`,
          value: "title",
          width: "30%",
        },
        {
          text: `${this.$t("notice.headers.description")}`,
          value: "description",
          class: "text-truncate",
          width: "25%",
        },
        {
          text: `${this.$t("notice.headers.date")}`,
          value: "created_at",
          width: "25%",
        },
        {
          text: `${this.$t("notice.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
      ],
      user: {},
      addPermissionDialog: false,
      deleteDialog: false,
      notices: [],
      delete_id: "",
      options: {
        sortBy: ["created_at"],
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler() {
        this.getNotices();
      },
      deep: true,
    },
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getNotices() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc =
        this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let _self = this;
      _self.$axios
        .get(
          "societyadmin/notices?society_id=" +
            _self.user.id +
            "&page=" +
            page +
            "&perPage=" +
            itemsPerPage +
            "&sortBy=" +
            sortBy +
            "&sortDesc=" +
            sortDesc +
            "&search=" +
            search
        )
        .then((response) => {
          _self.loading = false;
          let data = response.data;

          if (data.status) {
            _self.notices = data.notices;
            _self.totalRecords = data.total;
            _self.page = data.page > data.lastPage ? 1 : data.page;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
            if (data.type == "invalid") {
              localStorage.removeItem("user");
              _self.$router.push({ path: "/societyadmin/login" });
            }
          }
        });
    },
    deleteNotice(noticeId) {
      let _self = this;
      _self.$axios
        .delete("societyadmin/notices/" + noticeId)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getNotices();
            this.deleteDialog = false;
            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    debounceInput: debounce(function() {
      this.getNotices();
    }, 500),
    getFormattedDate(date) {
      return date ? moment(date).format("DD-MM-YYYY hh:mm A") : "N/A";
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("notice_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("notice_search", trimmedSearch);
      }
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.search = sessionStorage.getItem("notice_search");
  },
};
</script>
